import { UPDATEPIN } from "../../utils/api";
import axios from "../../utils/axios";

export const updatePin = async (param) => {
  const res = await axios.post(UPDATEPIN, param);
  return res;
};
